<template>
    <div></div>
</template>

<script>
export default {
    name: `SSOLink`,
    data() {
        return {
            title: ``
        }
    },
    mounted() {
        this.ssologin()
    },
    computed: {
        // ...mapGetters(["departments","hospitals","dept","accessDept"]),
        clientName() {
            //  return this.hospitals&&this.hospitals.length>0 ?this.hospitals[0].label:"--"
            return this.$root.HospitalName || ``
        }
    },
    methods: {
        ssologin(token) {
            let query = this.$route.query
            console.log(query)
            let querystring = ``
            _.each(query, (value, key) => {
                querystring += key + `=` + value + `&`
            })
            if (querystring == ``) {
                this.$message.error(`url参数不允许为空！`)
                return
            }
            querystring = querystring.trim(`&`)
            this.myaxios
                .post(`api/AcisSystem/Authorization/GetSSOToken`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: querystring
                })
                .then(data => {
                    console.log(data)
                    if (data && data.transUrl) {
                        window.location.href = data.transUrl
                    }
                })
        }
    }
}
</script>

<style scoped>
.first-page .el-header {
    background: black;
    color: whitesmoke;
    height: 30px !important;
}

.login_page {
    color: white;
    width: 100%;
    height: 100%;
    background-image: url('../assets/bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.login_page .half-opacity {
    color: rgba(255, 255, 255, 0.5);
}

.login_div {
    left: 50%;
    margin-left: -512px;
    top: 50%;
    margin-top: -260px;
    display: inline-block;
    position: fixed;
    background-repeat: no-repeat;
}

.login_div .el-row {
    padding-top: 20px;
}
.login_image {
    width: 640px;
    height: 480px;
    position: relative;
    border-radius: 15px 0 0 15px;
    background-image: url('../assets/anesthesia.jpg');
    background-repeat: no-repeat;
    background-position-x: -85px;
}

.product_slogon {
    padding: 20px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/SSOLink.vue